var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-wrapper"},[_c('Mail',{staticClass:"illustration"}),_c('a',{ref:"emailMeRef",attrs:{"href":"mailto:selimialtin@gmail.com?subject=Mail from altinselimi"}},[_vm._v("Click here to open your Mail app.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }